export const assetTypeOptions = [
  { label: "Default", value: 0 },
  { label: "Private Equity", value: 1 },
  { label: "ABS", value: 2 },
  { label: "Treasury Bonds", value: 3 },
  { label: "Venture Capital", value: 4 },
  { label: "Fixed Income", value: 5 },
  { label: "MBS", value: 6 },
  { label: "RMBS", value: 7 },
  { label: "Art", value: 8 },
  { label: "Real Estate", value: 9 },
  { label: "Collectibles", value: 10 },
  { label: "NFT", value: 11 },
];

/** Sentinel value for no asset-type filter (show everything). */
export const ALL_ASSET_TYPE_VALUE = -1;

export const allAssetTypeOption = { label: "All", value: ALL_ASSET_TYPE_VALUE };

export const assetTypeDropdownOptions = [allAssetTypeOption, ...assetTypeOptions];

/** Query params for GET /wallet/v1/get_asset_list */
export const buildAssetListParams = (assetTypeValue) => {
  if (assetTypeValue === ALL_ASSET_TYPE_VALUE) {
    return { asset_type: "all" };
  }
  return { asset_type: assetTypeValue };
};
